// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3cglk","title":"Header_title__3-Jmw","left":"Header_left__243uz","clinicName":"Header_clinicName__1Z6Fw"};